export default __webpack_public_path__ + "static/media/example-content5.74971fee.jpg";